'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.cntsInOneCatForMapEachYear = cntsInOneCatForMapEachYear;

var _dataCountryCodeJs = require('../../../data/countryCode.js');

/**
 * get all the countris in one cat for the map
 * @param  {array} arr     the output of the cntsInOneCatForLine
 * @param  {number} index  current index of year
 * @return {object}         as below
 */
/*
 {data:
  [
    {
      "code": "AF",
      "y": 53,
      "name": "Afghanistan"
    },
    {
      "code": "AL",
      "y": 117,
      "name": "Albania"
    },
    ...
  ]
}
*/

function cntsInOneCatForMapEachYear(arr, index) {
  var output = { data: [] };

  arr.forEach(function (d, i) {
    if (_dataCountryCodeJs.ctnCode[d['name']] !== undefined && d['data'][index] > 0) {
      output.data.push({
        name: d['name'],
        code: _dataCountryCodeJs.ctnCode[d['name']],
        value: d['data'][index]
      });
    }
  });

  //console.dir(output)
  return output;
}
//# sourceMappingURL=data:application/json;base64,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